import {
  Kicker,
  Stack,
  HeroHeadingTwo,
  TextLG,
  Box,
  Text,
  HStack,
  HeadingOne,
  Grid,
  Link,
  CheckIcon,
  Button,
  LinkExternalIcon,
  Flex,
} from "datastory-shared/ui"

import { Section } from "datastory-shared/sections"

import { DatastoryAcademySignup } from "../../components/DatastoryAcademySignup"

import { getPageProps } from "utils/ssg"

const Page = () => {
  const features = [
    "Skapa engagerande och effektfulla datavisualiseringar.",
    "Arbeta med viktiga samhällsfrågor och bidra till en kunskapsbaserad debatt.",
    "Lär dig om data: Samla in, filtrera och analysera statistik.",
  ]

  return (
    <>
      <Section>
        <Stack
          spacing={["xs", "md"]}
          w="container.xxl"
          pb="sm"
          textAlign="center"
          alignItems="center"
        >
          <Kicker color="primary.500">Datastory Academy</Kicker>
          <HeroHeadingTwo textAlign="center" whiteSpace={["pre-line", "unset"]}>
            {`Bli en datajournalist \n på 3 dagar!`}
          </HeroHeadingTwo>
          <TextLG whiteSpace={["unset", "pre-line"]}>
            {`Få tillgång till en värld av kunskap, utveckla färdigheter i
            datainsamling och visualisering – och skapa innehåll om ämnen du brinner för!`}
          </TextLG>
        </Stack>
      </Section>

      <Flex
        w="container.xxl"
        justifyContent="center"
        h="100%"
        bg="primary.50"
        fontWeight={600}
        p="sm"
      >
        <Flex
          gap={["xs", "lg"]}
          spacing={["xs", "md"]}
          h="100%"
          alignItems={["flex-start", "center"]}
          flexDir={["column", "row"]}
          justifyContent="center"
        >
          <Text>🎓 En kurs för ungdomar 13-16 år</Text>
          <Text>✅ 100% Gratis</Text>
        </Flex>
      </Flex>

      <Section mb="xxl" mt="md">
        <Grid variant="12" alignItems="flex-start">
          <Stack spacing="md">
            <HeadingOne>
              Lär dig om samhället och inspirera till förändring
            </HeadingOne>
            <Text>
              Delta i en inspirerande tredagarskurs i {""}
              <Link
                href="https://sv.wikipedia.org/wiki/Datajournalistik#:~:text=Datajournalistik%20%C3%A4r%20journalistik%20som%20bygger,%2C%20datavetenskap%2C%20statistik%20och%20datavisualisering."
                isExternal
                variant="standalone"
                color="primary.500"
                fontWeight={600}
                _hover={{ textDecoration: "underline" }}
              >
                datajournalistik
              </Link>{" "}
              med Datastory! Du väljer ett valfritt ämne och med hjälp av
              Datastory-plattformen kommer du att lära dig olika sätt att samla
              in data och presentera dina insikter i datavisualiseringar.
            </Text>
            <Stack>
              {features.map((feature, i) => (
                <HStack spacing="md" key={i}>
                  <Box
                    minW={["20px", "24px"]}
                    minH={["20px", "24px"]}
                    bg="blurble.500"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    borderRadius="50%"
                  >
                    <CheckIcon color="white" strokeWidth="3px" />
                  </Box>
                  <Text> {feature}</Text>
                </HStack>
              ))}
            </Stack>
            <Text>
              Vi söker dig som går i årskurs 7, 8 eller 9 och kan vara på plats
              i Stockholm. Kursen är alltså inte på distans.
              <br />
              <br />I slutet av kursen kommer alla deltagare att få ett intyg om
              slutförande av kurs och bli inbjudna att visa upp sina projekt på
              en lokal utställning. Bästa projektet kommer även att belönas!
            </Text>
            <Text>
              För frågor kontakta{" "}
              <Link
                variant="standalone"
                textAlign="center"
                href="mailto:hello@datastory.org?subject=Inquiry to Datastory"
                fontWeight={600}
                color="primary.500"
                _hover={{ textDecoration: "underline" }}
              >
                hello@datastory.org
              </Link>
            </Text>
            <Link
              href="https://sv.wikipedia.org/wiki/Datajournalistik#:~:text=Datajournalistik%20%C3%A4r%20journalistik%20som%20bygger,%2C%20datavetenskap%2C%20statistik%20och%20datavisualisering"
              pt="md"
              isExternal
            >
              <Button
                rightIcon={<LinkExternalIcon />}
                variant="outline"
                colorScheme="blurble"
              >
                Läs mer om datajournalistik
              </Button>
            </Link>
          </Stack>
          <DatastoryAcademySignup />
        </Grid>
      </Section>
    </>
  )
}

export const getStaticProps = async () => {
  return await getPageProps({
    namespaces: "",
  })
}

export default Page
